<div fxFlex="100" fxLayout="column" fxLayoutGap='15px'>
  <div fxFlex="100" fxLayout="row"  fxLayoutAlign="space-around center">

   <h2 fxFlex="100" fxLayoutAlign="space-around center">Formularz weryfikacji procesu sprzedaży</h2>


  </div>

  <div fxFlex="100" fxLayout="row"  fxLayoutAlign="left">


    <app-detail fxFlex="20" header="Data weryfikacji" [value]=" createdAtControl.value | date:'y-MM-dd'"></app-detail>

  </div>


  <div fxFlex="100" fxLayout="column" fxLayoutGap='15px'>

    <div fxFlex="100" fxLayout="row">
      <app-dict-ofwcas fxFlex="100"
         [multiple]="true" label="OFWCA biorące udział w kontroli " [status]="true"  [ofwcaItems]="items"  [control]="ofwcasControl" [required]="true"
      ></app-dict-ofwcas>
    </div>

    <div fxFlex="100" fxLayout="row">
      <br>
      Forma weryfikacji: Obserwacja OFWCA w trakcie realizacji procesu sprzedaży
      <br><br><br>
    </div>

  </div>

  <div fxFlex="100" fxLayout="column" fxLayoutGap='15px' >



    <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
      <div fxFlex="60">
        <b>
          Weryfikowany element - każdy element powinien być możliwy do udowodnienia przez OFWCA za pomocą obiektywnych środków dowodowych innych niż oświadczenie ustne OFWCA
        </b>
      </div>
      <div fxFlex="10" fxLayoutAlign="center">
        <b> NIE/TAK </b>
      </div>
      <div fxFlex="30">
       <b>
         Inne zastrzeżenia bądź uwagi powiązane z weryfikowanym elementem
       </b>
      </div>
    </div>

<br>

    <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60" > Czy OFWCA posługuje się aktualną i poprawną klauzulą IDD? </div>
        <div fxFlex="10" fxLayoutAlign="center">  <mat-slide-toggle [formControl]="bool0Control" color="accent"></mat-slide-toggle></div>
      <div fxFlex="30">
        <mat-form-field fxFlex="100">
          <textarea [readonly]="true" matInput [formControl]="value0Control" class="custom-textarea" ></textarea>
        </mat-form-field>
      </div>
    </div>

    <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
      <div fxFlex="60"> Czy OFWCA posługuje się aktualnymi  i poprawnymi  pełnomocnictwami  agencyjnymi? </div>
      <div fxFlex="10" fxLayoutAlign="center">  <mat-slide-toggle [formControl]="bool1Control" color="accent"></mat-slide-toggle></div>
      <div fxFlex="30">
        <mat-form-field fxFlex="100">
          <textarea [readonly]="true" matInput [formControl]="value1Control" class="custom-textarea"></textarea>
        </mat-form-field>
      </div>
    </div>

    <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
      <div fxFlex="60" > Czy OFWCA posługuje się aktualnymi  i poprawnymi  upoważnieniami OFWCA?</div>
      <div fxFlex="10" fxLayoutAlign="center">  <mat-slide-toggle [formControl]="bool2Control" color="accent"></mat-slide-toggle></div>
      <div fxFlex="30">
        <mat-form-field fxFlex="100">
          <textarea matInput [readonly]="true" [formControl]="value2Control" class="custom-textarea" [disabled]="true"></textarea>
        </mat-form-field>
      </div>
    </div>

    <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60"> Czy OFWCA udostępnia do zapoznania się każdemu Klientowi klauzulę IDD w formie papierowej lub innnego trwałego nośnika?</div>
        <div fxFlex="10"  fxLayoutAlign="center">  <mat-slide-toggle [formControl]="bool3Control" color="accent"></mat-slide-toggle></div>
        <div fxFlex="30">
          <mat-form-field fxFlex="100">
            <textarea [readonly]="true" matInput [formControl]="value3Control" class="custom-textarea"></textarea>
          </mat-form-field>
        </div>
    </div>

    <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
      <div fxFlex="60"> Czy OFWCA udostępnia do zapoznania się każdemu Klientowi pełnomocnictwa agencyjne oraz upoważnienia OFWCA?</div>
      <div fxFlex="10" fxLayoutAlign="center">  <mat-slide-toggle [formControl]="bool4Control" color="accent"></mat-slide-toggle></div>
      <div fxFlex="30">
        <mat-form-field fxFlex="100">
          <textarea [readonly]="true" matInput [formControl]="value4Control" class="custom-textarea"></textarea>
        </mat-form-field>
      </div>
    </div>

    <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
      <div fxFlex="60"> Czy OFWCA prowadzi analizę wymagań i potrzeb Klienta w każdym przypadku sprzedaży? </div>
      <div fxFlex="10" fxLayoutAlign="center">  <mat-slide-toggle [formControl]="bool5Control" color="accent"></mat-slide-toggle></div>
      <div fxFlex="30">
       <mat-form-field fxFlex="100">
         <textarea [readonly]="true" matInput [formControl]="value5Control" class="custom-textarea"></textarea>
       </mat-form-field>
      </div>
    </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60"> Czy OFWCA posługuje się aktualnymi wzorami OWU oraz IPID (Karta Produktu) do każdego produktu? </div>
        <div fxFlex="10" fxLayoutAlign="center">  <mat-slide-toggle [formControl]="bool6Control" color="accent"></mat-slide-toggle></div>
        <div fxFlex="30">
          <mat-form-field fxFlex="100">
            <textarea [readonly]="true" matInput [formControl]="value6Control" class="custom-textarea" ></textarea>
          </mat-form-field>
        </div>
      </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60"> Czy używana przez OFWCA Karta Produktu jest odrębnym od OWU dokumentem?</div>
        <div fxFlex="10" fxLayoutAlign="center">  <mat-slide-toggle [formControl]="bool7Control" color="accent"></mat-slide-toggle></div>
        <div fxFlex="30">
          <mat-form-field fxFlex="100">
            <textarea [readonly]="true" matInput [formControl]="value7Control" class="custom-textarea"></textarea>
          </mat-form-field>
        </div>
      </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60"> Czy każdy Klient otrzymuje od OFWCA OWU i Kartę Produktu?  </div>
        <div fxFlex="10" fxLayoutAlign="center">  <mat-slide-toggle [formControl]="bool8Control" color="accent"></mat-slide-toggle></div>
        <div fxFlex="30">
          <mat-form-field fxFlex="100">
            <textarea [readonly]="true" matInput [formControl]="value8Control" ></textarea>
          </mat-form-field>
        </div>
      </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60"> Czy Klient za każdym razem otrzymuje polisę papierową lub w formie innego trwałego nośnika?</div>
        <div fxFlex="10" fxLayoutAlign="center">  <mat-slide-toggle [formControl]="bool9Control" color="accent"></mat-slide-toggle></div>
        <div fxFlex="30">
          <mat-form-field fxFlex="100">
            <textarea [readonly]="true" matInput [formControl]="value9Control" ></textarea>
          </mat-form-field>
        </div>
      </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60"> Czy po zakończonym procesie sprzedaży Klient otrzymuje pakiet dokumentów - polisę lub jej skan, OWU, IPID? </div>
        <div fxFlex="10" fxLayoutAlign="center">  <mat-slide-toggle [formControl]="bool10Control" color="accent"></mat-slide-toggle></div>
        <div fxFlex="30">
          <mat-form-field fxFlex="100">
            <textarea [readonly]="true" matInput [formControl]="value10Control" ></textarea>
          </mat-form-field>
        </div>
      </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60"> Czy dokumentacja procesu sprzedaży została zarchiwizowana u OFWCA?  </div>
        <div fxFlex="10" fxLayoutAlign="center">  <mat-slide-toggle [formControl]="bool11Control" color="accent"></mat-slide-toggle></div>
        <div fxFlex="30">
          <mat-form-field fxFlex="100">
            <textarea [readonly]="true" matInput [formControl]="value11Control" ></textarea>
          </mat-form-field>
        </div>
      </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60"> Czy w weryfikowanych produktach znajdował się produkt życiowy?  </div>
        <div fxFlex="10" fxLayoutAlign="center">  <mat-slide-toggle [formControl]="bool12Control" color="accent"></mat-slide-toggle></div>
        <div fxFlex="30">
        </div>
      </div>

    <div fxFlex="100" fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start center">
      <div fxFlex="60">
        Czy w przypadku sprzedaży produktu życiowego zastosowano w pełni procedurę AML?
      </div>
      <div fxFlex="10" fxLayoutAlign="center center" class="align-checkbox">
        <mat-slide-toggle [formControl]="bool12aControl" color="accent"></mat-slide-toggle>
      </div>
      <div fxFlex="30" fxLayoutAlign="center center" class="align-textarea">
        <mat-form-field fxFlex="100">
          <textarea [readonly]="true" matInput [formControl]="value12aControl"></textarea>
        </mat-form-field>
      </div>
    </div>

    <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
      <div fxFlex="60"> Czy OFWCA przestrzega zakazu, o którym mowa w art. 25 UDU? </div>
      <div fxFlex="10" fxLayoutAlign="center">  <mat-slide-toggle [formControl]="bool17Control" color="accent"></mat-slide-toggle></div>
      <div fxFlex="30">
        <mat-form-field fxFlex="100">
          <textarea [readonly]="true" matInput [formControl]="value17Control" ></textarea>
        </mat-form-field>
      </div>
    </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60"> Czy stwierdzono inne nieprawidłowości nieuwzględnione w ankiecie?</div>
        <div fxFlex="10" fxLayoutAlign="center">  <mat-slide-toggle [formControl]="bool13Control" color="accent"></mat-slide-toggle></div>
        <div fxFlex="30">
          <mat-form-field fxFlex="100">
            <textarea [readOnly]="!bool13Control.value"  matInput placeholder=" jeśli tak to wymień jakie" [formControl]="value13Control" [required]="bool13Control.value"></textarea>
          </mat-form-field>
        </div>
      </div>

  </div>

<!--  <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>-->
<!--    <div fxFlex="30"> Zalecenia pokontrolne </div>-->
<!--    <div fxFlex="70">-->
<!--      <div *ngFor="let recommendation of value14Control.value">-->
<!--        <mat-form-field fxFlex="100">-->
<!--          <textarea matInput [value]="recommendation" disabled></textarea>-->
<!--        </mat-form-field>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->


  <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
    <div fxFlex="30"> Opis realizacji zaleceń z poprzedniej kontroli z dnia </div>
    <div fxFlex="70">
      <mat-form-field fxFlex="100">
        <textarea  matInput  [formControl]="value15Control" ></textarea>
      </mat-form-field>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="end">
    <button (click)="sendForm()" [class.spinner]="processingRequest" [disabled]="processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="closeDialog($event)"   [class.spinner]="processingRequest" [disabled]="processingRequest" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

</div>
